
// export const baseUrl = 'http://127.0.0.1:8000'
export const imagesUrl = 'http://127.0.0.1:8000'
// export const imagesUrl = 'http://127.0.0.1:8000'

// export const apiUrl = `${imagesUrl}/api`
export const baseUrl = `${imagesUrl}/api`

